import { render, staticRenderFns } from "./ErrorDescriptionCard.vue?vue&type=template&id=5334e46c&scoped=true"
import script from "./ErrorDescriptionCard.vue?vue&type=script&lang=js"
export * from "./ErrorDescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./ErrorDescriptionCard.vue?vue&type=style&index=0&id=5334e46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334e46c",
  null
  
)

export default component.exports